export const WHATSAPP_PHONE = '918088244799';
export const DISPLAY_PHONE = '+91 80882 44799';

export const WHATSAPP_DEFAULT_MESSAGE = "Hi%20ScanMaadi!%20I'm%20interested%20in%20your%20digital%20menu%20solution";
export const WHATSAPP_FAQ_MESSAGE = "Hi%20ScanMaadi!%20I%20have%20a%20question%20about%20your%20digital%20menu%20solution";

export const getWhatsAppUrl = (message: string = WHATSAPP_DEFAULT_MESSAGE): string =>
  `https://wa.me/${WHATSAPP_PHONE}?text=${message}`;
